import { render, staticRenderFns } from "./ThePageButton.vue?vue&type=template&id=1f22596a&scoped=true&"
import script from "./ThePageButton.vue?vue&type=script&lang=js&"
export * from "./ThePageButton.vue?vue&type=script&lang=js&"
import style0 from "./ThePageButton.vue?vue&type=style&index=0&id=1f22596a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f22596a",
  null
  
)

export default component.exports